export const objectCompare = (object1, object2) => {
    if (!object1) object1 = {}
    if (!object2) object2 = {}
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return true;

    for (let key of keys1) {
        if (object1[key] !== object2[key]) return true;
    }

    return false;
}

export const getFiltersLen = (filters) => {
    return filters && Object.values(filters)?.filter(x => x !== null && x !== '' && x !== undefined && x?.length !== 0)?.length;
}

export const removeByAttr = (arr, attr, value) => {
    let i = arr.length;
    while (i--) {
        if (arr[i]
            && arr[i].hasOwnProperty(attr)
            && (arguments.length > 2 && arr[i][attr] === value)) {
            arr.splice(i, 1);

        }
    }
    return arr;
}

export const searchInArray = (str, array, key) => {
    // Escape special characters in the search string
    const escapedStr = str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const pattern = new RegExp(escapedStr?.toLowerCase());
    return array.filter(data => {
        if (key) return !!data[key]?.toLowerCase()?.match(pattern);
        else return !!data?.toLowerCase()?.match(pattern);
    });
};

export const mergeObjects = (obj1, obj2) => {
    for (let key in obj2) {
        // If obj1 has this key and both values are objects, merge them recursively
        if (obj1.hasOwnProperty(key)) {
            // If both values are objects, merge them recursively
            if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
                mergeObjects(obj1[key], obj2[key]);
            } else {
                // Otherwise, overwrite the value in obj1 with the value from obj2
                obj1[key] = obj2[key];
            }
        }
    }
    return obj1; // Return the modified obj1
}

export const arrayEquals = (a, b) => {
    return (
        Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((val, index) => val === b[index])
    );
};

export const getIdObj = (arrName = []) => {
    const finalObject = {}
    arrName?.forEach(e => {
        finalObject[e._id] = e
    })
    return finalObject
}

export const ensureListValue = (value, fallback) => (Array?.isArray(value) && value?.length ? value : fallback);

export const removeEmpty = (obj) => {
    if (Array?.isArray(obj)) {
        return obj
            ?.map(item => removeEmpty(item))
            ?.filter(item => item !== null &&
                item !== "" &&
                !(Array?.isArray(item) && item?.length === 0) &&
                !(typeof item === "object" && !Array?.isArray(item) && Object.keys(item)?.length === 0)
            );
    }
    else if (typeof obj === "object" && obj !== null) {
        // Preserve Date objects
        if (obj instanceof Date) {
            return obj;
        };
        const cleanedObj = {};

        Object.keys(obj)?.forEach(key => {
            const value = removeEmpty(obj?.[key]);
            if (
                value !== null &&
                value !== "" &&
                !(Array?.isArray(value) && value?.length === 0) &&
                !(typeof value === "object" && !Array?.isArray(value) && !(value instanceof Date) && Object.keys(value)?.length === 0)
            ) {
                cleanedObj[key] = value;
            }
        });
        return cleanedObj;
    }
    return obj;
}

export const getObjectKey = (obj, value) => {
    if (!obj || typeof obj !== 'object') {
        return null;
    }
    return Object.keys(obj).find(key => obj[key] === value);
}

// ===== migrated from pms/src/common/functions/common.jsx =====
export const objectEqual = (object1, object2) => {
    if (object1 && object2) {

        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);

        if (keys1.length !== keys2.length) return false;

        for (let key of keys1) {
            if (object1[key] !== object2[key]) return false;
        }
        return true;
    } else return false;
};

export const groupBy = (objectArray, property) => {
    return objectArray.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
            acc[key] = [];
        }
        // Add object to list for given key's value
        acc[key].push(obj);
        return acc;
    }, {});
}

export const paginate = (array, limit, currentPage) => {
    // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
    return array.slice((currentPage - 1) * limit, currentPage * limit);
}

export const combinedItems = (arr = []) => {
    const res = arr.reduce((acc, obj) => {
        let found = false;
        for (let i = 0; i < acc.length; i++) {
            if (acc[i].date === obj.date) {
                found = true;
                acc[i].count++;
            }
        }
        if (!found) {
            obj.count = 1;
            acc.push(obj);
        }
        return acc;
    }, []);
    return res;
}

export const getValue = (value, array) => {
    return array?.find(e => e?.value === value)
}
